/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';

class PurchaseStatusPopupState {
  // @observable detuctedViews = 0;
  // @observable detuctedDownloads = 0;
  @observable toastMsg = '';

  @observable showStatusPopup = false;

  @action
  setToastMsg = (views, downloads, added, copied, listCreated, customTxt) => {
    let str = '';
    this.showStatusPopup = false;

    if (listCreated !== null && listCreated !== undefined)
      str += 'You have successfully created a list';

    if (views !== null && views !== undefined) {
      if (str !== '') str += ' <br />';
      if (Utils.isCreditBasedSubscription()) {
        if (views === 0 || views === '0') str += 'No credits deducted';
        else str += `${views} ${views > 1 ? 'credits' : 'credit'} deducted`;
      } else {
        console.log('old Flow');
        if (views === 0 || views === '0') str += 'No views deducted';
        else str += `${views} ${views > 1 ? 'views' : 'view'} deducted`;
      }
    }

    if (copied !== null && copied !== undefined)
      if (downloads !== null) str += 'Copied, ';
      else str += 'Copied';

    if (downloads !== null && downloads !== undefined)
      if (Utils.isCreditBasedSubscription()) {
        if (downloads === 0 || downloads === '0') str += 'No credits deducted';
        else
          str += `${downloads} ${
            downloads > 1 ? 'credits' : 'credit'
          } deducted`;
      } else {
        console.log('old FLow');
        if (downloads === 0 || downloads === '0')
          str += 'No downloads deducted';
        else
          str += `${downloads} ${
            downloads > 1 ? 'downloads' : 'download'
          } deducted`;
      }

    if (added !== null && added !== undefined) {
      if (str !== '') str += ' <br />';
      str += `${added} ${added > 1 ? 'contacts' : 'contact'} added to the list`;
    }

    if (customTxt !== null && customTxt !== undefined) {
      if (str !== '') str += ' <br />';
      str += customTxt;
    }

    const thisObj = this;
    console.log('time out', window.timeoutVar);
    if (window.timeoutVar !== undefined) clearTimeout(window.timeoutVar);
    setTimeout(function() {
      thisObj.showStatusPopup = true;
      thisObj.toastMsg = str;
      window.timeoutVar = setTimeout(function() {
        thisObj.showStatusPopup = false;
      }, 3000);
    }, 100);
  };
}
const purchaseStatusPopupState = new PurchaseStatusPopupState();

const PurchaseStatusPopup = observer(props => {
  return (
    <>
      <div
        className={`common-toast-wrapper${
          purchaseStatusPopupState.showStatusPopup ? ' show' : ''
        }`}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: purchaseStatusPopupState.toastMsg || '',
        }}
      />
    </>
  );
});

export { PurchaseStatusPopup, purchaseStatusPopupState };
export default PurchaseStatusPopup;
